export default[
    {
        path: '/comissionador/cadastro',
        name: 'cadastro', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/comissionador/lista',
        name: 'lista', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/empresa/editar',
        name: 'editar dados da empresa', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]